import { Flex, IconButton, Tooltip } from "@chakra-ui/react";
import React from "react";
import { useLocalStorage } from "../../../hooks/localStorage/useLocalStorage";
import { SidebarCollapseIcon } from "../../../images/icons/components/SidebarCollapseIcon";
import { SidebarExpandIcon } from "../../../images/icons/components/SidebarExpandIcon";
import { TOP_NAV_ZINDEX } from "./Navbar";
import { DesktopNavbarHeader } from "./NavbarHeader";
import { NavbarLinks } from "./NavbarLinks";

const EXPANDED_NAV_WIDTH = "12.5rem";
const COLLAPSED_NAV_WIDTH = "4rem";

export function DesktopNavbar({ accountId }: { accountId: string }) {
  const [storedIsCollapsed, setStoredIsCollapsed] = useLocalStorage<unknown>(
    "syla.navbar.IsCollapsed",
    false,
  );

  const isCollapsed = storedIsCollapsed === true;

  const toggleCollapsed = () => {
    setStoredIsCollapsed((value: unknown) => value !== true);
  };

  const toggleLabel = isCollapsed ? "Expand" : "Collapse";

  return (
    <Flex
      as="nav"
      backgroundColor="gray.900"
      h="full"
      maxH="full"
      overflowY="auto"
      // width must have explicit values to get smooth animation
      w={isCollapsed ? COLLAPSED_NAV_WIDTH : EXPANDED_NAV_WIDTH}
      shrink={0}
      direction="column"
      zIndex={TOP_NAV_ZINDEX}
      py={2}
      transition="width 0.2s ease"
      align="center"
      justify="space-between"
      gap={2}
      px={2}
    >
      <Flex w="full" direction="column" gap={2} align="flex-start">
        <DesktopNavbarHeader accountId={accountId} isCollapsed={isCollapsed} />
        <NavbarLinks isCollapsed={isCollapsed} />
      </Flex>

      <Flex w="full" justify={isCollapsed ? "center" : "flex-end"}>
        <Tooltip
          label={toggleLabel}
          placement={isCollapsed ? "right" : "top"}
          hasArrow
        >
          <IconButton
            aria-label={toggleLabel}
            icon={
              isCollapsed ?
                <SidebarExpandIcon boxSize="1.5rem" />
              : <SidebarCollapseIcon boxSize="1.5rem" />
            }
            colorScheme="gray"
            variant="ghost"
            onClick={toggleCollapsed}
          />
        </Tooltip>
      </Flex>
    </Flex>
  );
}
